export default __webpack_public_path__ + "032bfe0b8f838d5b4a22c497a001e333.svg";